import { put } from 'redux-saga/effects';

import * as endpoint from 'misc/endpoint';
import * as types from 'misc/types';

export function* searchArchives(action) {
    try {
        let search_results = {
            searchTerm: action.searchTerm,
            filterTag: action.filterTag
        };
        

        let searchUrl = 'envelopes?tagged=_ARCHIVED';

        if(action.filterTag){
            searchUrl += ','+action.filterTag.id;
        }

        if(action.searchTerm){
            searchUrl += '&searchTerm='+action.searchTerm;
        }

        const response = yield endpoint.get(
            searchUrl
        );
       
        // Add key attribute to envelopes
        response.data.forEach(function(envelope) {
            envelope.key = envelope.id;
        });

        /*
        const nrResults = Math.random() * (10 - 2) + 2;
        let results = [];
        for (var i = 0; i < nrResults; i++) {
            results.push({
                id: 'd2c27ab0-58d1-48b5-ab3d-fdd32899e288',
                key: i,
                title: 'asdf',
                timeStamp: '2018-01-01',
                stamp: 1,
                state: {
                    read: true
                },
                sender: {
                    name: 'Avsändare'
                }
            });
        }
        */

        search_results.results = response.data;

        yield put({ type: types.SAGA_ARCHIVES_SEARCH_GET.SUCCESS, payload: search_results });
    } catch (error) {
        yield put({ type: types.SAGA_ARCHIVES_SEARCH_GET.FAILURE, error });
    }
}



// WEBPACK FOOTER //
// ./src/sagas/search_results.js